/**
 * Сетка разграфки на карте ОИ (prefs + id слоя; GeoJSON — через visualizer builder).
 */

export {
  buildVisualizerGridFeatureCollection as buildOiMapGridFeatureCollection,
} from "@/lib/visualizer-snap-grid";

export const OI_MAP_GRID_STORAGE_KEY = "gpml.oi.mapGrid";

/** Шаг разграфки в метрах (пресеты для ОИ). */
export const OI_MAP_GRID_STEP_PRESETS = [
  25_000, 50_000, 100_000, 200_000, 500_000,
] as const;

export type OiMapGridStepMeters = (typeof OI_MAP_GRID_STEP_PRESETS)[number];

export type OiMapGridPrefs = {
  grid: boolean;
  stepMeters: OiMapGridStepMeters;
};

export const DEFAULT_OI_MAP_GRID_PREFS: OiMapGridPrefs = {
  grid: false,
  stepMeters: 50_000,
};

export const OI_MAP_GRID_SOURCE = "oi-map-grid";
export const OI_MAP_GRID_LAYER = "oi-map-grid-line";

function isStep(value: unknown): value is OiMapGridStepMeters {
  return (
    typeof value === "number" &&
    (OI_MAP_GRID_STEP_PRESETS as readonly number[]).includes(value)
  );
}

export function loadOiMapGridPrefs(): OiMapGridPrefs {
  try {
    const raw = localStorage.getItem(OI_MAP_GRID_STORAGE_KEY);
    if (!raw) return { ...DEFAULT_OI_MAP_GRID_PREFS };
    const parsed = JSON.parse(raw) as Partial<OiMapGridPrefs>;
    return {
      grid: Boolean(parsed.grid),
      stepMeters: isStep(parsed.stepMeters)
        ? parsed.stepMeters
        : DEFAULT_OI_MAP_GRID_PREFS.stepMeters,
    };
  } catch {
    return { ...DEFAULT_OI_MAP_GRID_PREFS };
  }
}

export function saveOiMapGridPrefs(prefs: OiMapGridPrefs): void {
  try {
    localStorage.setItem(OI_MAP_GRID_STORAGE_KEY, JSON.stringify(prefs));
  } catch {
    /* ignore */
  }
}

/** Подпись шага для select (км). */
export function formatOiMapGridStepLabel(stepMeters: number): string {
  const km = stepMeters / 1000;
  return Number.isInteger(km) ? `${km} км` : `${km.toLocaleString("ru-RU")} км`;
}
